'use client';

export { default } from './Collapse';
export { default as collapseClasses } from './collapseClasses';
export * from './collapseClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Collapse/index.js
// module id = 265
// module chunks = 22